import { Trans, useTranslation } from '@hopin-team/provider-translation';
import { Logo } from '@hopin-team/ui-logo';
import React from 'react';

export const RouteNotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center flex-col text-center min-h-[95vh]">
      <div>
        <Logo type="ringcentral-default" />
        <h1 className="m-0 p-0 no-underline border-none font-semibold not-italic text-[2rem] leading-[2.5rem] mt-6 mb-6">
          {t('routeNotFound.heading')}
        </h1>
        <p className="mx-0 my-2 p-0 no-underline border-none font-normal not-italic text-sm leading-6 text-[rgb(105,110,124)]">
          {t('routeNotFound.title')}
        </p>
        <p className="mx-0 my-2 p-0 no-underline border-none font-normal not-italic text-sm leading-6 text-[rgb(105,110,124)]">
          <Trans i18nKey="routeNotFound.body">
            content
            <a href="/" target="_blank" rel="noreferrer">
              home link
            </a>
            content
            <a
              href="https://support.ringcentral.com/events.html"
              target="_blank"
              rel="noreferrer"
            >
              support link
            </a>
            content
          </Trans>
        </p>
      </div>
    </div>
  );
};
